import React, { useEffect } from "react";
import { useI18n } from "@/context/I18nContext";
import { SITE_NAME, DEFAULT_OG_IMAGE, absoluteUrl } from "@/lib/seo";

// Componente SEO riutilizzabile basato sul supporto nativo ai document metadata
// di React 19 (title/meta/link sollevati automaticamente nel <head>).
// La meta description è gestita in modo imperativo per evitare duplicati con
// il tag statico presente in public/index.html (React 19 non lo deduplica).
export const Seo = ({
  title,
  description,
  path = "/",
  image,
  type = "website",
  noindex = false,
  jsonLd,
}) => {
  const { lang } = useI18n();
  const canonical = absoluteUrl(path);
  const ogImage = image || DEFAULT_OG_IMAGE;
  const ogLocale = lang === "en" ? "en_US" : "it_IT";
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);

  return (
    <>
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex,follow" : "index,follow"} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={ogLocale} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }} />
      ))}
    </>
  );
};

export default Seo;
